import {Description} from "../../components/about/Description";
import {Support} from "../../components/about/Support";
import {Feedback} from "../../components/about/Feedback";
import {BetaTest} from "../../components/about/BetaTest";
import {CompanyInfo} from "../../components/about/CompanyInfo";
import {BaseLayout} from "../../layouts/Base";

export const AboutPage = () => {
    return (
        <BaseLayout>
            <Description/>
            <Support/>
            <Feedback/>
            <BetaTest/>
            <CompanyInfo/>
        </BaseLayout>
    )
}